// v9modular方式の初期化
import { initializeApp } from 'firebase/app'

// configでdomainごとに場合分け
const firebaseConfig = {
  apiKey: process.env.API_KEY,
  authDomain: process.env.AUTH_DOMAIN,
  databaseURL: process.env.DATABASE_URL,
  projectId: process.env.PROJECT_ID,
  storageBucket: process.env.STORAGE_BUCKET,
  messagingSenderId: process.env.MESSAGING_SENDER_ID,
  appId: process.env.APP_ID,
  measurementId: process.env.MEASUREMENT_ID
}

// Initialize Firebase for v9
const firebaseApp = initializeApp(firebaseConfig)

export { firebaseApp }



// WEBPACK FOOTER //
// ./src/firebase.js